module.exports = __webpack_public_path__ + "img/home-restaurant-thumb-03.da9e8029.jpg";